import { useEffect, useRef, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleLogoSVG } from "../../../assets";

export default function GoogleLoginButton({
  text = "Sign in with Google",
  onSuccess,
  onError,
}) {
  const buttonRef = useRef(null);
  const [loginWidth, setLoginWidth] = useState();

  useEffect(() => {
    if (!buttonRef.current) {
      return;
    }

    const updateWidth = () => {
      const currentWidth = buttonRef.current?.getBoundingClientRect().width;
      setLoginWidth(currentWidth ? Math.round(currentWidth) : undefined);
    };

    updateWidth();

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateWidth);
      resizeObserver.observe(buttonRef.current);
    }

    window.addEventListener("resize", updateWidth);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  return (
    <>
      <button
        type="button"
        className="google-login-button"
        ref={buttonRef}
      >
        <span className="google-logo-wrapper" aria-hidden="true">
          <GoogleLogoSVG className="google-logo" />
        </span>
        <span className="google-login-text">{text}</span>
        <GoogleLogin
          onSuccess={(res) => {
            if (!res?.credential) {
              return onError?.("Failed to receive Google ID Token");
            }
            onSuccess?.({ credential: res.credential });
          }}
          onError={() => onError?.("Google login failed")}
          containerProps={{
            style: {
              opacity: '0.0001',
              position: "absolute",
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 99999,
            },
          }}
          width={loginWidth}
        />
      </button>
    </>
  );
}